import { render, staticRenderFns } from "./BoutiqueBox.vue?vue&type=template&id=d93ccc6c&scoped=true&"
import script from "./BoutiqueBox.vue?vue&type=script&lang=js&"
export * from "./BoutiqueBox.vue?vue&type=script&lang=js&"
import style0 from "./BoutiqueBox.vue?vue&type=style&index=0&id=d93ccc6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93ccc6c",
  null
  
)

export default component.exports